import { Modal } from "react-bootstrap";
import styled from "styled-components";

const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: ${(props) => props.maxWidth || "416px"};
  }

  .modal-content {
    border: none;
    border-radius: 2px;
    box-shadow:
      var(--shadow-modal-layer-1),
      var(--shadow-modal-layer-2),
      var(--shadow-modal-layer-3);

    .modal-body {
      padding: ${(props) =>
        props.isWarningPopUp ? "32px 32px 24px 32px" : "24px"};
    }

    .modal-footer {
      border-top: ${(props) =>
        props.isWarningPopUp
          ? "0px solid"
          : "0.5px solid var(--color-light-grey)"} !important;
      padding: ${(props) =>
        props.isWarningPopUp ? "0px 32px 24px 32px" : "16px 24px"} !important;
    }
  }
`;

export default StyledModal;
